let filters = [];

function normalizePrice(price) {

    //remove all non digit chars except . and ,
    price = price.toString().replace(/\s|[a-zA-Z]+/gi, '');

    //number contains more then 1 .
    if( (price.match(/\./gi) || []).length > 1 && 
        (price.match(/\,/gi) || []).length == 0) {
        price = price.replace(/\./gi, '');
    }

    //number contains more then 1 ,
    if( (price.match(/\,/gi) || []).length > 1 && 
        (price.match(/\./gi) || []).length == 0) {
        price = price.replace(/\,/gi, '');
    }

    //number contains atleast 1 , and 1 .
    if( (price.match(/\./gi) || []).length > 0 && 
        (price.match(/\,/gi) || []).length > 0) {

        if (price.replace(/\d/gi, '').charAt(0) == '.') {
            price = price.replace(/\./gi, '');
        } else {
            price = price.replace(/\,/gi, '');
        }
    }

    //replace , by .
    return parseFloat(price.replace(/\,/gi, '.'));
}

function formatPrice(price, decimals = 5) {
    
    return normalizePrice(price).toFixed(decimals).replace('.', ',');
}

function getVatRate(elementSelector, vatRate) {
    for (var i = 0; i < $(elementSelector)[0].options.length; ++i) {
        if ($(elementSelector)[0].options[i].value == vatRate) {
            return $(elementSelector)[0].options[i].dataset.rate;
        }
    }
}

function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

function round(num){
	return Math.round((num + 2.220446049250313e-16) * 100) / 100;
}

function getVat(vatRate) {
    return config.webshop.vat[vatRate];
}

function getPrice(price, vatRate) {

    let val, vat;
    if (config.webshop.type == 'B2C') {

        if (vatRate == '0' || vatRate == null) {
            val = parseFloat(price);
        } else {
            val = parseFloat(price) * ((getVat(vatRate) / 100) + 1);
        }

    } else{
        val = parseFloat(price);
    }

    return number_format(val, 2, ',', '');
}

function getCurrency() {

    return config.webshop.currency == 'euro'
        ? '&euro;'
        : (config.webshop.currency == 'pound'
            ? '₤'
            : '$');
}

function getLocalePrice(price, vatRate = null) {
    return getCurrency()+" "+getPrice(price, vatRate);
}

function collapseChilds(element, type) {

    if (type == 'fadein') {

        element.removeClass('collapsed');
        element.find('svg').attr('data-icon', 'minus-square');

        $('[data-collapse-link-child='+element.data('collapse-link')+']').each(function() {

            $(this).removeClass('collapse-hidden');

            if ($(this).find('.collapser').length > 0) {
                collapseChilds($(this).find('.collapser'), type);
            }
            
        });
    } else {

        element.addClass('collapsed');
        element.find('svg').attr('data-icon', 'plus-square');

        $('[data-collapse-link-child='+element.data('collapse-link')+']').each(function() {
            
            $(this).addClass('collapse-hidden');

            if ($(this).find('.collapser').length > 0) {
                collapseChilds($(this).find('.collapser'), type);
            }
    
        });
    }
}

function preventDefault(e) {
    if(e.preventDefault){
        e.preventDefault();
    }
    else {
        e.returnValue = false;
    }
}

function htmlentities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function tinyMCESetReadOnly(editors) {
    editors.forEach(function(editor) {
        if ($('#'+editor.id).hasClass('texteditor-readonly')) {
            editor.setMode('readonly'); 
            editor.getBody().style.backgroundColor = '#e9ecef';
        }
    });
}

function setLoading(sSelector, state = 'add') {

    if (state == 'add' && $(sSelector).find('.loading').length == 0) {
        console.log('load');
        var sLoading = '<div class="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>'
        $(sSelector).append(sLoading);
    }
    else if (state == 'remove') {
        $(sSelector).find('.loading').remove();
    }
}

$( document ).ready(function() {

    $(document).on('click', '.table tr.clickable', function() {
        window.location.href = $(this).data('href');
    });

    $(document).on('click', '.btn-delete', function() {
    
        let name = 'this item', 
            text = '';
   
        if (typeof $(this).data('name') != 'undefined') {
            name = "<b>"+$(this).data('name')+"</b>";
        }

        if (typeof $(this).data('text') != 'undefined') {
            text = "<br>"+$(this).data('text')+"";
        }
        
        new Modal({
            "title": 'Are you sure',
            "content": "Are you sure you want to delete "+name+"?"+text,
            "buttons": [
                '<button type="button" class="btn btn-primary btn-cancel-modal" data-dismiss="modal">Cancel</button>',
                '<button type="button" class="btn btn-danger btn-delete-confirm" data-href="'+$(this).data('href')+'">Yes</button>'
            ]
        });
    });

    $(document).on('click', '.btn-copy', function (e) {

        let parts = [];
        $('input[name="parts[]"]:checked').each(function () {
            parts.push($(this).val());
        });

        location.href = location.href + "?action=copy&id=" + $(this).data('id') + "&parts=" + parts.join(',');
    });

    $(document).on('click', '.btn-copy-quick', function (e) {
        location.href = location.href + "?action=copy&id="+$(this).data('id');
    });


    // products overview specific functions //
    $(document).on('click', '.ptn-copy-quick', function (e) {
        location.href = location.href + "?action=copy&id="+$(this).closest('.row-item').data('id');
    });

    $(document).on('click', '.ptn-modify', function (e) {
        location.href = config.domain+"/admin/products/modify/"+$(this).closest('.row-item').data('id');
    });
    
    $(document).on('click', '.ptn-delete', function (e) {

        let name = 'this item', 
            text = '';
   
        if (typeof $(this).data('name') != 'undefined') {
            name = "<b>"+$(this).data('name')+"</b>";
        }

        if (typeof $(this).data('text') != 'undefined') {
            text = "<br>"+$(this).data('text')+"";
        }
        
        new Modal({
            "title": 'Are you sure',
            "content": "Are you sure you want to delete "+name+"?"+text,
            "buttons": [
                '<button type="button" class="btn btn-primary btn-cancel-modal" data-dismiss="modal">Cancel</button>',
                '<button type="button" class="btn btn-danger btn-delete-confirm" data-href="'+config.domain+"/admin/products/delete/"+$(this).closest('.row-item').data('id')+'">Yes</button>'
            ]
        });
    });    
    // //////////////////////////////////// //

    $(document).on('click', '.btn-cancel-modal', function() {
        $(this).closest('.modal').modal('hide');
    });

    $(document).on('click', '.btn-delete-confirm', function(){
        window.location.href = $(this).data('href');
    });

    $('.template-slogan-switch').on('change', function () {

        $($(this).data('container')).hide();
        if ($(this).is(':checked')) {
            $($(this).data('container')).show();
        }
    });

    $('.has-mobile-inputs').on('change', function () {

        if ($(this).is(':checked')) {
            $('.input-mobile').each(function () {
                $(this).removeClass('d-none');
            });
        } else {
            $('.input-mobile').each(function () {
                $(this).addClass('d-none');
            });
        }
    });

    $(document).on('click', '.download-export', function () {
        
        let type = typeof $(this).data('type') == 'undefined'
            ? 'default'
            : $(this).data('type');

        let export_type = typeof $(this).data('export_type') == 'undefined'
        ? ''
        : $(this).data('export_type');

        $.ajax({
            url: config.domain+"/"+config.app+"/functions/export.php",
            type: 'post',
            data: {
                "dir": $(this).data('dir'),
                "type": type,
                "export_type": export_type
            },
            success: function(response) {

                let filename = response.split('/');
                filename = filename[filename.length - 1]
                if (response != '0') {
                    var link = document.createElement('a');
                    link.href = $('body').data('url')+'/'+response;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                }
            }
        });
    });

    $(document).on('change', '.switch-input-type', function() {
        
        if ($(this).is(':selected')) {
            $($(this).data('checked')).removeAttr('disabled');
            $($(this).data('checked')).prop('disabled', false);

            $($(this).data('unchecked')).attr('disabled', 'disabled');
            $($(this).data('unchecked')).prop('disabled', true);
            $($(this).data('unchecked')).val('');

        } else {       
            $($(this).data('unchecked')).removeAttr('disabled');
            $($(this).data('unchecked')).prop('disabled', false);

            $($(this).data('checked')).attr('disabled', 'disabled');
            $($(this).data('checked')).prop('disabled', true);
            $($(this).data('checked')).val('');
        }

        if (typeof $($(this).data('checked')).data('type') !== 'undefined' &&
            $($(this).data('checked')).data('type') == 'selectpicker') {
            $($(this).data('checked')).selectpicker('destroy');
            $($(this).data('checked')).selectpicker('render');
        }

        if (typeof $($(this).data('unchecked')).data('type') !== 'undefined' &&
            $($(this).data('unchecked')).data('type') == 'selectpicker') {
            $($(this).data('unchecked')).selectpicker('destroy');
            $($(this).data('unchecked')).selectpicker('render');
        }
    });

    $(document).on('change', '#is_button', function(){

        if ($(this).is(':checked')) {
            $('.button-link').slideDown();
            $('.button-text').slideDown();
            
        } else {
            $('.button-link').slideUp();
            $('.button-text').slideUp();
        }
    });

    $(document).on('click', 'form ul.nav-languages .nav-link, ul.nav-languages .nav-link', function () {
        if($(this).hasClass('nav-link-shipment')) {
            $('#shipment-lang-active').val($(this).attr('title'));
        } else {
            $('#lang-active').val($(this).attr('title'));
        }
    });

    $(document).on('click', 'form ul.nav-domains .nav-link, ul.nav-domains .nav-link', function () {
        $('#domain-active').val($(this).attr('title'));
    });

    $(document).on('change', '.price-normalize', function(e) {

        let decimals = typeof $(this).data('decimals') !== 'undefined'
                ? parseInt($(this).data('decimals'))
                : 5;

        if ($(this).val() == '') {
            $(this).val('0,'+decimals);
        }

        $(this).val(formatPrice($(this).val(), decimals));
    });

    $(document).on('keyup change', '.price-calculator', function(e) {

        if (typeof $(this).data('type') === 'undefined' ||
            typeof $(this).data('selector') === 'undefined' ||
            typeof $(this).data('vat') === 'undefined' || 
            $($(this).data('selector')).length == 0) {
                console.log('price-calculator data incomplete');
            return;
        }

        let decimals = typeof $(this).data('decimals') !== 'undefined'
                ? parseInt($(this).data('decimals'))
                : 5,
            vat = $($(this).data('vat')).prop('nodeName') != 'INPUT'
                    ? getVatRate(
                        $(this).data('vat'), 
                        $($(this).data('vat')).selectpicker('val'))
                    : $($(this).data('vat')).val();

        if ($(this).val() == '') {
            $(this).val('0,'+decimals);
        }

        if (e.type == 'keyup') {
            if ($(this).data('type') == 'excl') {
                $($(this).data('selector')).val(formatPrice(normalizePrice($(this).val()) * ((vat / 100) + 1), decimals));
            } else {
                $($(this).data('selector')).val(formatPrice(normalizePrice($(this).val()) / ((vat / 100) + 1), decimals));
            }
        } else {
            $(this).val(formatPrice($(this).val(), decimals));
        }
    });

    if ($('.price-calculator[data-type=excl]').length > 0) {
        $('.price-calculator[data-type=excl]').trigger('keyup');
    }

    $('.filterable').each(function() {
        filters.push(new Filterable($(this)));
    });

    $('.filterable-pagination').each(function() {
        var overview = new FilterablePagination($(this));
        overview.setVisibility();
        filters.push(overview);
    });

    $('.iconpicker').each(function() {
        new IconPicker($(this));
    });

    $('.preview-seo').each(function() {
        new PreviewerSEO($(this));
    });

    if ($('form ul.nav-languages, ul.nav-languages').length > 0) {
        $('#lang-active').val($('form ul.nav-languages .nav-link.active').attr('title'));
    }

    $('.datepicker').datepicker({
        format: 'dd-mm-yyyy'
    });

    $('.previewer').each(function() {
        new Previewer($(this));
    });
    

    $('.color-picker').colorpicker({ format: 'hex' });

    $('.color-picker-rgba').colorpicker({ format: 'rgba' });

    $(document).on('keyup', '.input-number', function() {
        $(this).val($(this).val().replace(/[^\d]/,''));
    });

    $('.input-tags').each(function() {
        new tagsPicker($(this));
    });
    
    makeOverviewsSortable();

    $(document).on('click', '.overview .collapsable', function(e) {

        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('collapsed')) {
            collapseChilds($(this), 'fadein');

        } else {
            collapseChilds($(this), 'fadeout');
        }
    }); 

    $(document).on('click', '.btn-collapse-all', function(e) {

        $('.overview .collapsable').each(function() {

            collapseChilds($(this), 'fadeout');

            // $(this).addClass('collapsed');
            // $(this).find('svg').attr('data-icon', 'plus-square');
            // $(this).closest('.row-item').children('.child-rows').hide();
        });

        $('.btn-uncollapse-all').removeClass('d-none');
        $(this).addClass('d-none');
    });

    $(document).on('click', '.btn-uncollapse-all', function(e) {

        $('.overview .collapsable').each(function() {

            collapseChilds($(this), 'fadein');
            // $(this).removeClass('collapsed');
            // $(this).find('svg').attr('data-icon', 'minus-square');
            // $(this).closest('.row-item').children('.child-rows').show();
        });

        $('.btn-collapse-all').removeClass('d-none');
        $(this).addClass('d-none');
        
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('.switch-checkbox').on('change', function (e) {
        if ($(this).prop('checked')) {
            $(this).next().val(1);
        } else {
            $(this).next().val(0);
        }
    });

    $(document).on('change', '.domain-landing-switch', function () {

        $(this).closest('div.domain-landing').find('div.landing-slug').slideUp();
        if ($(this).is(':checked')) {
            $(this).closest('div.domain-landing').find('div.landing-slug').slideDown();
        }
    });

    $('.domain-landing-switch').trigger('change');

    let formObserver = new FormObserver();

    new Seo();

    if ($('.download-files').length > 0) {
        new FileUploader('.download-files');
    }

    tinymce.init({
        selector: '.texteditor',
        content_css : config.domain+"/assets/dist/css/style.css,"+config.domain+"/admin/assets/dist/css/tinymce.css?s="+new Date().getTime(),
        body_class: 'style style-primary',

        link_list: function(success) { 
            success(links[$('form ul.nav-languages .nav-link.active').attr('title')]); // pass link_list data to TinyMCE
        },

        body_id: 'page',
        link_class_list: buttons,
        min_height: 300,
        max_height: 600,
        width: '100%',
        paste_as_text: true,
        menubar: false,
        plugins: 'image media quickbars link lists wordcount code paste autoresize table',
        toolbar:
            'undo redo | ' +
            'bold italic underline strikethrough | ' +
            'outdent indent | ' +
            'numlist bullist | ' +
            'insertfile image media template link anchor table | ' +
            'removeformat | code',
        automatic_uploads: true,
        file_picker_types: 'image',
        relative_urls: false,
        images_upload_url: config.domain+'/'+config.app+'/functions/editor_upload_image.php',
        paste_data_images: true,
        quickbars_selection_toolbar: 'bold italic | h1 h2 h3 h4 h5 h6 | link',
        file_picker_callback: function (cb, value, meta) {
            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.onchange = function () {
                var file = this.files[0];

                // var sFilename = file.name.split('.');
                // sFilename.pop();
                // sFilename = sFilename.join('.');


                var reader = new FileReader();
                reader.onload = function () {
                    var id = 'blobid' + (new Date()).getTime();
                    // var id = sFilename;
                    var blobCache = tinymce.activeEditor.editorUpload.blobCache;
                    var base64 = reader.result.split(',')[1];
                    var blobInfo = blobCache.create(id, file, base64);
                    blobCache.add(blobInfo);
                    console.log(blobInfo.blobUri());
                    cb(blobInfo.blobUri(), { title: file.name });
                };
                reader.readAsDataURL(file);
            };
            input.click();
        },
        init_instance_callback: function (editor) {
            editor.on('Change', function (e) {
                if (typeof formObserver !== 'undefined') {
                    formObserver.changed = true;
                }
            });
        }
    }).then(function(editors) {
        tinyMCESetReadOnly(editors);
    });

    tinymce.init({
        selector: '.texteditor-mini',
        content_css : config.domain+"/assets/dist/css/style.css,"+config.domain+"/admin/assets/dist/css/tinymce.css?s="+new Date().getTime(),
        body_class: 'style style-primary',

        link_list: function (success) {
            success(links[$('form ul.nav-languages .nav-link.active').attr('title')]); // pass link_list data to TinyMCE
        },

        link_class_list: buttons,
        min_height: 200,
        max_height: 600,
        width: '100%',
        paste_as_text: true,
        menubar: false,
        plugins: 'link lists wordcount autoresize paste code',
        toolbar:
            'undo redo | ' +
            'bold italic underline strikethrough | ' +
            'numlist bullist | ' +
            'link | ' +
            'removeformat | code',
        init_instance_callback: function (editor) {
            editor.on('Change', function (e) {
                if (typeof formObserver !== 'undefined') {
                    formObserver.changed = true;
                }
            });
        }
    }).then(function(editors) {
        tinyMCESetReadOnly(editors);
    });

    tinymce.init({
        selector: '.texteditor-plaintext',
        min_height: 200,
        max_height: 600,

        link_list: function (success) {
            success(links[$('form ul.nav-languages .nav-link.active').attr('title')]); // pass link_list data to TinyMCE
        },
        
        width: '100%',
        paste_as_text: true,
        menubar: false,
        plugins: 'link lists wordcount autoresize paste code',
        toolbar:
            'undo redo | ' +
            'bold italic underline strikethrough | ' +
            'link | ' +
            'removeformat | code',
        init_instance_callback: function (editor) {
            editor.on('Change', function (e) {
                if (typeof formObserver !== 'undefined') {
                    formObserver.changed = true;
                }
            });
        }
    }).then(function(editors) {
        tinyMCESetReadOnly(editors);
    });
    
});

function makeOverviewsSortable(){
    $('.overview .sortable').sortable({
        handle: ".sorting-handle",
        stop: function (e, ui) {

            var list = [];

            let sortcol = 'sort';
            if (typeof $(e.target).data('sort') != 'undefined') {
                sortcol = $(e.target).data('sort');
            }

            let categoryId = '';
            if(config.uri == 'admin/products' && $('#category_ids').length > 0) {
                categoryId = $(document).find('#category_ids option:selected').data('id');

                if(categoryId == 'all') {
                    categoryId = '';
                }
            }

            if (typeof $(e.target).find('.row-item').first().data('tablename') != 'undefined') {

                $(e.target).find('.row-item').each(function () {
                    list.push({
                        id: $(this).data('id'),
                        tablename: $(this).data('tablename')
                    });
                });

            } else {

                $(e.target).find('.row-item').each(function () {
                    list.push({
                        id: $(this).data('id')
                    });
                });
            }

            $.ajax({
                url: config.domain + "/" + config.app + "/functions/update_sort.php",
                type: 'post',
                data: {
                    'type': $(e.target).closest('.overview').data('type'),
                    'sortcol': sortcol,
                    'category_id': categoryId,
                    'sort': JSON.stringify(list)
                },
                success: function (data) {

                    if($('.body.sortable .row-item').length > 0) {
                        let counter = 1;
                        $.each( $('.body.sortable .row-item'), function( key, item ) {
                            if($(item).find('.sort_counter').length > 0) {
                                $(item).find('.sort_counter').html(counter);
                                counter++;
                            }
                        });
                    }

                }
            });

        }
    });
}